'use client'

import LoanModalShell from '@/app/components/loanComparator/modals/LoanModalShell'
import AppButton from '@/app/components/atomic/molecules/AppButton'

export default function LoanPdfHowItWorksModal({ onClose }: { onClose: () => void }) {
    return (
        <LoanModalShell
            badge={{ label: 'Import intelligent', tone: 'success' }}
            title="Comment ça marche ?"
            onClose={onClose}
            maxWidthClassName="max-w-[600px]"
        >
            <div className="flex flex-col gap-4">
                <div>
                    <p className="m-0 text-[14px] font-semibold text-pale">Ce qu&apos;on fait</p>
                    <p className="m-0 mt-1 text-[15px] text-pale/80">
                        Quand vous importez votre offre de prêt, un système d&apos;intelligence artificielle lit le
                        document pour en extraire automatiquement les informations utiles (montant emprunté, taux,
                        durée, banque, etc.) et pré-remplir le formulaire à votre place.
                    </p>
                </div>

                <div className="flex gap-3 rounded-xl border border-rm-blue-light bg-rm-blue-accent-bg p-4">
                    <i className="fa-regular fa-shield-halved mt-0.5 text-rm-blue-accent" />
                    <div>
                        <p className="m-0 text-[14px] font-semibold text-pale">Ce qu&apos;on ne fait pas</p>
                        <p className="m-0 mt-1 text-[14px] text-pale/80">
                            Le fichier n&apos;est pas stocké : une fois les informations extraites, il est immédiatement
                            supprimé. Seules les données extraites (et nécessaires à votre dossier) sont conservées.
                        </p>
                    </div>
                </div>

                <ul className="m-0 flex list-none flex-col gap-3 p-0">
                    <li className="flex gap-3">
                        <i className="fa-regular fa-circle-check mt-0.5 text-green-800" />
                        <p className="m-0 text-[14px] text-pale/80">
                            <span className="font-semibold text-pale">Vous gardez le contrôle</span> — les champs
                            pré-remplis restent modifiables : vérifiez et corrigez-les avant de continuer.
                        </p>
                    </li>
                    <li className="flex gap-3">
                        <i className="fa-regular fa-circle-check mt-0.5 text-green-800" />
                        <p className="m-0 text-[14px] text-pale/80">
                            <span className="font-semibold text-pale">Qui traite la donnée</span> — l&apos;analyse est
                            réalisée par Mistral, Anthropic et Réassurez-moi, dans le seul but de faciliter votre saisie.
                        </p>
                    </li>
                </ul>

                <AppButton theme="orange" arrowPosition="before" wFull onClick={onClose} dataTest="pdf-how-it-works-close">
                    J&apos;ai compris
                </AppButton>

                <p className="m-0 text-center text-[13px] text-pale/70">
                    Pour plus de détails, consultez notre{' '}
                    <a href="/politique-de-confidentialite" target="_blank" className="underline">
                        Politique de confidentialité
                    </a>
                    .
                </p>
            </div>
        </LoanModalShell>
    )
}
